import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import SubNavigationItems, { SubNavigationItemProps } from "go-app/components/Navigation/SubNavigationItems";

export const GroupReportsNavigation: FC = () => {
	const { t } = useTranslation();
	const prefix = `/reports`;

	const items: SubNavigationItemProps[] = [
		{
			title: t("modules.state_report.header.title"),
			route: `${prefix}/states`,
		},
		{
			title: t("modules.product_report.header.title"),
			route: `${prefix}/products`,
		},
		{
			title: t("modules.purchase_report.header.title"),
			route: `${prefix}/purchases`,
		},
		{
			title: t("modules.sale_report.header.title"),
			route: `${prefix}/sales`,
			isActiveRoute: (_, location) =>
				location.pathname.startsWith(`${prefix}/sales`) &&
				!location.pathname.startsWith(`${prefix}/sales/products`),
		},
		{
			title: t("modules.transfer_report.header.title"),
			route: `${prefix}/transfers`,
		},
		// {
		// 	title: t("modules.fifo_report.header.title"),
		// 	route: `${prefix}/fifo`,
		// },
		{
			title: t("modules.stocktaking_report.header.title"),
			route: `${prefix}/stocktakings`,
		},
		{
			title: t("modules.product_sale_report.header.title"),
			route: `${prefix}/sales/products`,
		},
		{
			title: t("modules.price_report.header.title"),
			route: `${prefix}/prices`,
		},
		{
			title: t("modules.correction_report.header.title"),
			route: `${prefix}/corrections`,
		},
		{
			title: t("modules.adjustment_report.header.title"),
			route: `${prefix}/adjustments`,
		},
	];

	return <SubNavigationItems title={t("components.navigation.reports.title")} items={items} />;
};
